import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const ActivityBody: React.FC<ActivityBodyProps> = ({
  children,
  className,
}) => {
  return <div className={cn('ml-13', className)}>{children}</div>;
};
